import * as Yup from 'yup';
export const initialContentTypeValues = {
    name: '',
    description: '',
};
export const contentTypeSchema = Yup.object().shape({
    name: Yup.string(),
    description: Yup.string(),
});
//# sourceMappingURL=content-type.js.map